import { pStudio } from 'src/app/helpers/permission';
import { MenuItem } from 'src/app/models/menu-item';

export const MENU: MenuItem[] = [
  {
    title: 'menu.dashboard',
    route: '/private/dashboard',
    icon: '',
    svgIcon: 'dashboard',
    child: [],
    permissions: []
  },
  {
    title: 'staff.name',
    route: 'staffs',
    icon: '',
    svgIcon: 'staff-alt',
    permissions: [],
    child: [
      {
        title: 'staff.list',
        route: ['/private/staff'],
        icon: '',
        svgIcon: 'listing',
        permissions: []
      },
      {
        title: 'development.name',
        route: ['/private/staff/development'],
        icon: '',
        svgIcon: 'feedback',
        permissions: []
      },

    ]
  },
  {
    title: 'report.name',
    route: 'report',
    icon: '',
    svgIcon: 'report',
    permissions: [],
    child: []
    // child: [
    //   {
    //     title: 'staff.list',
    //     route: ['/private/staff'],
    //     icon: '',
    //     svgIcon: 'listing',
    //     permissions: []
    //   },
    //   {
    //     title: 'development.name',
    //     route: ['/private/staff/development'],
    //     icon: '',
    //     svgIcon: 'feedback',
    //     permissions: []
    //   },

    // ]
  },
  {
    title: 'report.s15',
    route: 'report-s15',
    icon: '',
    svgIcon: 'report',
    permissions: [],
    child: []
    // child: [
    //   {
    //     title: 'staff.list',
    //     route: ['/private/staff'],
    //     icon: '',
    //     svgIcon: 'listing',
    //     permissions: []
    //   },
    //   {
    //     title: 'development.name',
    //     route: ['/private/staff/development'],
    //     icon: '',
    //     svgIcon: 'feedback',
    //     permissions: []
    //   },

    // ]
  },

];
